type FactorySource = Object | unknown;
export class Factory<T> {
    constructor(private type: new () => T) {}
    getFactory(source: FactorySource): T {
        return Object.assign(new this.type(), source);
    }
}
